export default "__VITE_ASSET__23d097c2__"